<template>
<!-- :visible="showLookPic"  :width="$route.path != '/customerRoom' ? '' : '530px'"-->
<el-dialog :visible="true" :close-on-click-modal="false" @close="handleClose" title="对照录入图片">
  <div class="look-Entry-pic">
    <div class="crossreference-box left-table">
      <!-- 对照录入 -->
      <div class="crossreference-tabs">
        <el-tabs v-model="activeName" @tab-click="handleTabClick">
          <el-tab-pane name="second">
            <span slot="label">
              <span>录入任务</span>
              <!-- <span v-if="patientFilesIteFocusNumber"> ({{patientFilesIteFocusNumber > 99 ? '99+' : patientFilesIteFocusNumber}})</span> -->
            </span>
          </el-tab-pane>
          <el-tab-pane name="first">
            <span slot="label">
              <span>其他单据</span>
              <!-- <span v-if="patientFilesItemOtherNumber"> ({{patientFilesItemOtherNumber > 99 ? '99+' : patientFilesItemOtherNumber}})</span> -->
            </span>
          </el-tab-pane>
          <el-tab-pane label="无效" name="third">
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 病历夹 -->
      <div v-show="activeName == 'second'" class="crossReference medicalRecordFolder">
        <div class="crossReference-reminder-search search-line">
          <div style="flex:1.5">
            <el-date-picker size="mini" style="width:100%" v-model="medicalQueryObj.medicalQueryTime" type="daterange"
              range-separator="至" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </div>
          <div class="file-name" style="flex:1">
            <el-input placeholder="请输入文件名称" prefix-icon="el-icon-search" v-model="medicalQueryObj.nameLike" size="mini"
              clearable>
            </el-input>
          </div>
          <el-button type="primary" size="mini" @click="searchFolder">搜索</el-button>
        </div>
        <div v-if="JSON.stringify(medicalFolderList) != '{}'" class="quote-all-check">
          <el-checkbox :disabled="disabledAllMedical" :indeterminate="allIndeterMedical" v-model="allMedical" @change="handleCheckMedicalAll"></el-checkbox>
          <el-button :disabled="!medicalUrls.length" size="mini" @click="handleBatchQuote" style="height:24px">批量引用</el-button>
        </div>

        <el-scrollbar style="height: calc(100% - 100px);font-size: 12px">
          <div class="record-folder-content" v-for="(it, key, ind) in medicalFolderList" :key="ind">
            <div class="record-folder-time">
              <span class="circle-dot"></span>
              <span class="time">{{key}}</span>
            </div>
            <ul>
              <!-- :style="`cursor:unset;background:${picList1[defaultInstanceIndex].url === item.url ? '#edf4fe' : ''}`" -->
              <el-checkbox-group v-model="medicalUrls" @change="handleCheckMedicalChange">
              <li v-for="(item,index) in it" :key="index" @click="handleLookImg(item)" style="cursor:unset;">
                <el-checkbox style="margin-right:10px" 
                  :disabled="patientMedicalDocs.indexOf(`${imgPath}${item.url}`) != -1 || 
                    (medicalUrls.length == 99 - (patientMedicalDocs.length + otherUrls.length + invalidUrls.length) ? (medicalUrls.indexOf(`${imgPath}${item.url}`) == -1 ? true : false) : false)" 
                  :label="`${imgPath}${item.url}`">&nbsp;</el-checkbox>
                <div class="refeImg">
                  <img src="@/assets/images/jpg-pic.png" alt="" style="width:45px">
                </div>
                <div class="refeFileName" :style="{cursor:item.statusName == '患者删除' ? 'unset':'pointer'}">
                  <!-- <div class="refeFileName-top" :class="item.status == 3?'through-del':''">{{ item.url.split('?x-oss')[0].substring(item.url.split('?x-oss')[0].lastIndexOf("/")+1,item.url.split('?x-oss')[0].length) }}</div> -->
                  <div class="refeFileName-top" :class="item.statusName == '患者删除'?'through-del':''">
                    <span :title="item.name">{{ item.name }}</span>
                    <el-tooltip placement="top">
                      <div slot="content">
                        <div style="margin-bottom:4px">关联图片：</div>
                        <p style="margin-top:8px" v-for="(relatePic,k) in item.relatedPictures" :key="k">{{relatePic}}</p>
                      </div>
                      <img v-if="item.haveRelatedPictures" src="@/assets/images/link.png" alt="">
                    </el-tooltip>
                  </div>
                  <div class="refeFileName-bot" v-if="item.patientSchemeName && item.doctorTeamName">
                    {{ item.patientSchemeName }}-{{ item.doctorTeamName }}</div>
                </div>
                <div class="upFileName">
                  <div style="margin-bottom:10px;color:#666666;font-size:12px" :class="item.statusName == '患者删除'?'through-del':''">
                    {{ item.createUserName }}</div>
                  <div style="font-size:12px;color:#999" :class="item.statusName == '患者删除'?'through-del':''">{{ item.createTime }}
                  </div>
                </div>
                <div class="fileType" style="width:60px"
                  :style="`color: ${item.statusName == '未录入' ? 'red' : item.statusName == '已录入' ? '#00C281' :
                    item.statusName == '患者删除' ? 'rgba(0, 0, 0, 0.24)':item.statusName == '草稿'?'rgba(0, 0, 0, 0.24)':''}`">
                  <span v-if="item.statusName == '未录入'" style="background: red" class="iconfont icon-point"></span>
                  <span v-if="item.statusName == '已录入'" style="background: #00C281" class="iconfont icon-point"></span>
                  <span v-if="item.statusName == '患者删除'" style="background: rgba(0, 0, 0, 0.24)"
                    class="iconfont icon-point"></span>
                  <span v-if="item.statusName == '草稿'" style="background: rgba(0, 0, 0, 0.24)"
                    class="iconfont icon-point"></span>
                  <!-- {{ item.status == 1 ? '未录入' : item.status == 2 ? '已录入' : item.status == 3 ? '患者删除' : ''  item.status == 4 ? '录入中' : '' item.status == 5 ? '录入中' : ''}} -->
                  {{ item.statusName }}
                </div>
                <div v-if="patientMedicalDocs.indexOf(`${imgPath}${item.url}`) == -1" class="option-entry-status" @click="handleQuote(item)">
                  <span class="can-entry">引用</span>
                </div>
                <div v-else class="option-entry-status">
                  <span class="no-can-entry">已引用</span>
                </div>
              </li>
              </el-checkbox-group>
            </ul>
          </div>
          <div style="font-size:12px;color:#ccc;text-align:center;margin-top:50px;margin-bottom:30px">
            人家是有底线的~
          </div>
          <!-- <div v-else class="al-task" @click="loadPatientFilesItem">
            <span>加载图片<i class="el-icon-arrow-down"></i></span>
          </div> -->
        </el-scrollbar>
      </div>
      <!-- 其他单据 -->
      <div v-show="activeName == 'first'" class="crossReference medicalRecordFolder">
        <div class="crossReference-reminder-search search-line">
          <div style="flex:1.5">
            <el-date-picker size="mini" style="width:100%" v-model="medicalQueryObj.medicalQueryTime" type="daterange"
              range-separator="至" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </div>
          <div class="file-name" style="flex:1">
            <el-input placeholder="请输入文件名称" prefix-icon="el-icon-search" v-model="medicalQueryObj.nameLike" size="mini" clearable>
            </el-input>
          </div>
          <el-button type="primary" size="mini" @click="searchFolder">搜索</el-button>
        </div>
        <div v-if="JSON.stringify(otherFolderList) != '{}'" class="quote-all-check">
          <el-checkbox :disabled="disabledAllOther" :indeterminate="allIndeterOther" v-model="allOther" @change="handleCheckOtherAll"></el-checkbox>
          <el-button :disabled="!otherUrls.length" size="mini" @click="handleBatchQuote" style="height:24px">批量引用</el-button>
        </div>
        <el-scrollbar style="height: calc(100% - 100px);font-size: 12px">
          <div class="record-folder-content" v-for="(it, key, ind) in otherFolderList" :key="ind">
            <div class="record-folder-time">
              <span class="circle-dot"></span>
              <span class="time">{{key}}</span>
            </div>
            <ul>
              <el-checkbox-group v-model="otherUrls" @change="handleCheckedOtherChange">
              <li v-for="(item,index) in it" :key="index" @click="handleLookImg(item)" style="cursor:unset">
                <!-- <el-checkbox style="margin-right:10px" v-model="item.checkAll" @change="(val) => {handleCheckedItemChange(val, item)}"></el-checkbox> -->
                <el-checkbox style="margin-right:10px" 
                  :disabled="patientMedicalDocs.indexOf(`${imgPath}${item.url}`) != -1 || 
                    (otherUrls.length == 99 - (patientMedicalDocs.length + medicalUrls.length + invalidUrls.length) ? (otherUrls.indexOf(`${imgPath}${item.url}`) == -1 ? true : false) : false)" 
                  :label="`${imgPath}${item.url}`">&nbsp;</el-checkbox>
                <div class="refeImg">
                  <!-- <span v-if="item.read" class="yet-read">已读</span>
                  <span v-else class="no-read">未读</span> -->
                  <img src="@/assets/images/jpg-pic.png" alt="" style="width:45px">
                </div>
                <div class="refeFileName" :style="{cursor:item.statusName == '患者删除' ? 'unset':'pointer'}" style="width:45%">
                  <!-- <div class="refeFileName-top" :class="item.status == 3?'through-del':''">{{ item.url.split('?x-oss')[0].substring(item.url.split('?x-oss')[0].lastIndexOf("/")+1,item.url.split('?x-oss')[0].length) }}</div> -->
                  <div class="refeFileName-top" :class="item.statusName == '患者删除'?'through-del':''">
                    <span :title="item.name">{{ item.name }}</span>
                    <el-tooltip placement="top">
                      <div slot="content">
                        <div style="margin-bottom:4px">关联图片：</div>
                        <p style="margin-top:8px" v-for="(relatePic,k) in item.relatedPictures" :key="k">{{relatePic}}</p>
                      </div>
                      <img v-if="item.haveRelatedPictures" src="@/assets/images/link.png" alt="">
                    </el-tooltip>
                  </div>
                  <div class="refeFileName-bot" v-if="item.patientSchemeName && item.doctorTeamName">
                    {{ item.patientSchemeName }}-{{ item.doctorTeamName }}</div>
                </div>
                <div class="upFileName">
                  <div style="margin-bottom:6px;color:#666666;font-size:12px" :class="item.statusName == '患者删除'?'through-del':''">
                    {{ item.createUserName }}</div>
                  <div style="font-size:12px;color:#999" :class="item.statusName == '患者删除'?'through-del':''">{{ item.createTime }}
                  </div>
                </div>
                <div class="fileType" style="width:68px;color:#00C281">
                  <span style="background: #00C281" class="iconfont icon-point"></span>
                  无需录入
                </div>
                <!-- <div class="fileType" style="width:60px;color:rgba(0, 0, 0, 0.24)">
                  <span style="background: rgba(0, 0, 0, 0.24)" class="iconfont icon-point"></span>
                  患者删除
                </div> -->
                <div v-if="patientMedicalDocs.indexOf(`${imgPath}${item.url}`) == -1" class="option-entry-status" @click="handleQuote(item)">
                  <span class="can-entry">引用</span>
                </div>
                <div v-else class="option-entry-status">
                  <span class="no-can-entry">已引用</span>
                </div>
              </li>
              </el-checkbox-group>
            </ul>
          </div>
          <div style="font-size:12px;color:#ccc;text-align:center;margin-top:50px;margin-bottom:30px">
            人家是有底线的~
          </div>
          <!-- <div v-else class="al-task" @click="loadPatientFilesItem">
            <span>加载图片<i class="el-icon-arrow-down"></i></span>
          </div> -->
        </el-scrollbar>
      </div>
      <!-- 无效 -->
      <div v-show="activeName == 'third'" class="crossReference">
        <div class="crossReference-reminder-search search-line">
          <div>
            <!-- <label>服务链名称</label> -->
            <el-select v-model="patientFilesItemV2VO.wholeCourseId" filterable placeholder="请选择服务链名称" size="mini"
              clearable>
              <el-option v-for="item in schemeNameList" :key="item.wholeCourseId" :label="item.name"
                :value="item.wholeCourseId">
              </el-option>
            </el-select>
          </div>
          <div class="file-name">
            <el-input placeholder="请输入文件名称" prefix-icon="el-icon-search" v-model="patientFilesItemV2VO.keyWord"
              size="mini" clearable>
            </el-input>
          </div>
          <el-button type="primary" size="mini" @click="searchInvalid">搜索</el-button>
        </div>
        <div v-if="invalidFileList.length" class="quote-all-check" style="padding-left:20px">
          <el-checkbox :disabled="disabledAllInvalid" :indeterminate="allIndeterInvalid" v-model="allInvalid" @change="handleCheckInvalidAll"></el-checkbox>
          <el-button :disabled="!invalidUrls.length" size="mini" @click="handleBatchQuote" style="height:24px">批量引用</el-button>
        </div>
        <el-scrollbar style="height: calc(100% - 100px);font-size: 12px">
          <!-- v-if="patientFilesItemV2VO.patientFilesItemFlag" -->
          <ul>
            <el-checkbox-group v-model="invalidUrls" @change="handleCheckedInvalidChange">
            <li v-for="(item,index) in invalidFileList" :key="index"
              @click="handleLookImg(item)">
              <!-- <el-checkbox style="margin-right:10px" v-model="item.checkAll" @change="(val) => {handleCheckedItemChange(val, item)}"></el-checkbox> -->
              <el-checkbox style="margin-right:10px" 
                :disabled="patientMedicalDocs.indexOf(`${imgPath}${item.url}`) != -1 || 
                  (invalidUrls.length == 99 - (patientMedicalDocs.length + otherUrls.length + medicalUrls.length) ? (invalidUrls.indexOf(`${imgPath}${item.url}`) == -1 ? true : false) : false)" 
                :label="`${imgPath}${item.url}`">&nbsp;</el-checkbox>
              <div class="refeImg">
                <img :src="item.icon" alt="">
              </div>
              <div class="refeFileName">
                <div class="refeFileName-top" style="color:#999999;text-decoration:line-through" :title="item.fileName">{{ item.fileName }}</div>
                <div class="refeFileName-bot" v-if="item.patientSchemeName && item.doctorTeamName">
                  {{ item.patientSchemeName }}-{{ item.doctorTeamName }}</div>
              </div>
              <div class="upFileName">
                <div style="margin-bottom:10px;color:#666666;font-size:12px">{{ item.uploadUserName }}</div>
                <div style="font-size:12px;color:#999">{{ item.createTime }}</div>
              </div>
              <div class="fileType" style="color:#666666;width:40px">
                <span style="background: #666666" class="iconfont icon-point"></span>
                无效
              </div>
              <div v-if="patientMedicalDocs.indexOf(`${imgPath}${item.url}`) == -1" class="option-entry-status" @click="handleQuote(item)">
                <span class="can-entry">引用</span>
              </div>
              <div v-else class="option-entry-status">
                <span class="no-can-entry">已引用</span>
              </div>
            </li>
            </el-checkbox-group>
          </ul>
          <div style="font-size:12px;color:#ccc;text-align:center;margin-top:50px;margin-bottom:30px">
            人家是有底线的~
          </div>
        </el-scrollbar>
      </div>
    </div>
    
    <div v-if="picList1[defaultInstanceIndex]" class="right-pic">
      <!-- <div class="quote-top-btn">
        <el-button type="primary" size="mini" @click="handleQuote(picList1[defaultInstanceIndex])">引用</el-button>
      </div> -->
      <div class="preview-imgs" v-if="picList1.length">
        <MultipleOptionImg ref="instanceImgRef" :oneImg="false" :key="instanceTimer" :loadIndex="1" :otherList="picList1" :defaultIndex="defaultInstanceIndex" @changeInstanceArrow="changeInstanceArrow"/>
      </div>
    </div>
  </div>
</el-dialog>
</template>

<script>
import { getSchemeNameByPatientId } from "@/views/newPatientmanage/api/treatmentPlan.js";
import MultipleOptionImg from "@/components/MultipleOptionImg.vue";
import { queryMedicalFold,getPatientFilesItemList } from "@/api/crossreentry";
// import CrossReferenDialog from "../CrossReferenceEntry/newindex";
// import AddMedicalFolder from "./AddMedicalFolder";
// import { lockInGroupFile } from "@/api/enteryDetailPage";
// import { DEEP_CLONE } from "@/utils/constants";

export default {
  // name: "crossReference",
  props: {
    showLookPic: {
      type: Boolean,
      default: true
    },
    patientMedicalDocs: {
      type: Array,
      default: () => []
    },
    patientId:{
      type:String,
      default:""
    },
  },
  components: {
    MultipleOptionImg
    // CrossReferenDialog,
    // AddMedicalFolder,
    // LookEntryPic: () => import("@/components/CrossReferenceEntry/LookEntryPic.vue")
  },
  data() {
    return {
      imgPath: process.env.VUE_APP_OSS_URL,
      defaultInstanceIndex: 0,
      picList1: [],
      instanceTimer: 0,
      patientFilesItemV2VO: {},
      routeEntry: 1,
      selectOtherFile: {},
      // showLookPic: false,
      newestList: [],
      current: 1,
      size: 20,
      invalidFileList: [],
      medicalFolderList: {},
      medicalQueryObj: {
        medicalQueryTime: [],
        nameLike: ""
        // current: 1,
        // size: 10
      },
      medicalFolderStatus: false,
      value1: "",
      activeName: "second",
      crossReferenItem: {},
      showCrossReferen: false,
      otherFolderList: {},
      otherNewestList: [],
      schemeNameList: [], // 获取服务名称列表

      
      allIndeterMedical: false,
      allMedical: false,
      medicalUrls: [],

      allIndeterOther: false,
      allOther: false,
      otherUrls: [],

      allIndeterInvalid: false,
      allInvalid: false,
      invalidUrls: [],
    };
  },
  watch: {},
  computed: {
    disabledAllMedical() {
      let arr = []
      this.picList1.map(v => {
        if (this.patientMedicalDocs.indexOf(`${this.imgPath}${v.url}`) == -1) {
          arr.push(this.imgPath + v.url)
        }
      })
      //  + this.medicalUrls.length
      if (arr.length + this.patientMedicalDocs.length + this.otherUrls.length + this.invalidUrls.length > 99) {
        return true
      } else {
        return false
      }
    },
    disabledAllOther() {
      let arr = []
      this.picList1.map(v => {
        if (this.patientMedicalDocs.indexOf(`${this.imgPath}${v.url}`) == -1) {
          arr.push(this.imgPath + v.url)
        }
      })
      //  + this.otherUrls.length
      if (arr.length + this.patientMedicalDocs.length + this.medicalUrls.length + this.invalidUrls.length > 99) {
        return true
      } else {
        return false
      }
    },
    disabledAllInvalid() {
      let arr = []
      this.picList1.map(v => {
        if (this.patientMedicalDocs.indexOf(`${this.imgPath}${v.url}`) == -1) {
          arr.push(this.imgPath + v.url)
        }
      })
      //  + this.invalidUrls.length
      if (arr.length + this.patientMedicalDocs.length + this.medicalUrls.length + this.otherUrls.length > 99) {
        return true
      } else {
        return false
      }
    }
  },
  created() {
    this.getSchemeNameList(this.patientId)
    this.getMedicalFoldList();
  },
  methods: {
    handleCheckMedicalAll(val) {
      this.medicalUrls = []
      console.log(this.picList1)
      val ? this.picList1.map(v => {
        if (this.patientMedicalDocs.indexOf(`${this.imgPath}${v.url}`) == -1) {
          // this.imgPath + v.url
          // return this.imgPath + v.url
          this.medicalUrls.push(this.imgPath + v.url)
        }
      }) : this.medicalUrls = [];
      console.log(this.medicalUrls)
      this.allIndeterMedical = false;
    },
    handleCheckMedicalChange(value) {
      console.log(value)
      let checkedCount = value.length;
      let filterNoCheckArr = []
      this.picList1.map(v => {
        if (this.patientMedicalDocs.indexOf(`${this.imgPath}${v.url}`) == -1) {
          // this.imgPath + v.url
          // return this.imgPath + v.url
          filterNoCheckArr.push(this.imgPath + v.url)
        }
      })
      this.allMedical = checkedCount === filterNoCheckArr.length;
      this.allIndeterMedical = checkedCount > 0 && checkedCount < filterNoCheckArr.length;
    },

    handleCheckOtherAll(val) {
      // this.otherUrls = val ? this.picList1.map(v => this.imgPath+v.url) : [];
      // this.allIndeterOther = false;
      this.otherUrls = []
      console.log(this.picList1)
      val ? this.picList1.map(v => {
        if (this.patientMedicalDocs.indexOf(`${this.imgPath}${v.url}`) == -1) {
          // this.imgPath + v.url
          // return this.imgPath + v.url
          this.otherUrls.push(this.imgPath + v.url)
        }
      }) : this.otherUrls = [];
      console.log(this.otherUrls)
      this.allIndeterOther = false;
    },
    handleCheckedOtherChange(value) {
      // let checkedCount = value.length;
      // this.allOther = checkedCount === this.picList1.length;
      // this.allIndeterOther = checkedCount > 0 && checkedCount < this.picList1.length;
      console.log(value)
      let checkedCount = value.length;
      let filterNoCheckArr = []
      this.picList1.map(v => {
        if (this.patientMedicalDocs.indexOf(`${this.imgPath}${v.url}`) == -1) {
          // this.imgPath + v.url
          // return this.imgPath + v.url
          filterNoCheckArr.push(this.imgPath + v.url)
        }
      })
      this.allOther = checkedCount === filterNoCheckArr.length;
      this.allIndeterOther = checkedCount > 0 && checkedCount < filterNoCheckArr.length;
    },

    handleCheckInvalidAll(val) {
      // this.invalidUrls = val ? this.picList1.map(v => this.imgPath+v.url) : [];
      // this.allIndeterInvalid = false;
      this.invalidUrls = []
      console.log(this.picList1)
      val ? this.picList1.map(v => {
        if (this.patientMedicalDocs.indexOf(`${this.imgPath}${v.url}`) == -1) {
          // this.imgPath + v.url
          // return this.imgPath + v.url
          this.invalidUrls.push(this.imgPath + v.url)
        }
      }) : this.invalidUrls = [];
      console.log(this.invalidUrls)
      this.allIndeterInvalid = false;
    },
    handleCheckedInvalidChange(value) {
      // let checkedCount = value.length;
      // this.allInvalid = checkedCount === this.picList1.length;
      // this.allIndeterInvalid = checkedCount > 0 && checkedCount < this.picList1.length;
      console.log(value)
      let checkedCount = value.length;
      let filterNoCheckArr = []
      this.picList1.map(v => {
        if (this.patientMedicalDocs.indexOf(`${this.imgPath}${v.url}`) == -1) {
          // this.imgPath + v.url
          // return this.imgPath + v.url
          filterNoCheckArr.push(this.imgPath + v.url)
        }
      })
      this.allInvalid = checkedCount === filterNoCheckArr.length;
      this.allIndeterInvalid = checkedCount > 0 && checkedCount < filterNoCheckArr.length;
    },
    // 批量引用
    handleBatchQuote() {
      this.$emit('getQuoteData',[...this.medicalUrls,...this.otherUrls,...this.invalidUrls])
      this.$emit('update:showLookPic', false)
    },
    //患者状态
    filterTypeHandel(status) {
      switch (status * 1) {
        case 1:
          return "未申请";
        case 2:
          return "未入案";
        case 3:
          return "评估中";
        case 4:
          return "待医生确认";
        case 5:
          return "进行中";
        // case 6 :
        //     return '医生驳回'
        case 7:
          return "未开始";
        // case 8 :
        //     return '已退款'
        // case 9 :
        //     return '待病人确认'
        // case 10 :
        //     return '病人驳回'
        // case 11 :
        //     return '医生取消'
        case 12:
          return "服务结束";
        default:
          return "未知状态";
      }
    },
    // 获取服务名称列表
    async getSchemeNameList(patientId) {
      let { code, data } = await getSchemeNameByPatientId({ patientId });
      if (code === 0) {
        this.schemeNameList = data.map(item => {
          return {
            ...item,
            name: `${item.name}(${this.filterTypeHandel(item.status)})`
          }
        })
        
      }
    },
    handleQuote(item) {
      console.log(item,'item数据')
      this.$emit('getQuoteData',[`${this.imgPath}${item.url}`])
      this.$emit('update:showLookPic', false)
    },
    // otherFolderList  invalidFileList  medicalFolderList
    handleLookImg(item) {
      // if (this.activeName == 'first') {
      //   this.picList1 = [].concat.apply([],Object.values(this.otherFolderList))
      // }
      // if (this.activeName == 'second') {
      //   this.picList1 = [].concat.apply([],Object.values(this.medicalFolderList))
      //   // console.log(this.picList1,'病历夹图片')
      // }
      // if (this.activeName == 'third') {
      //   this.picList1 = this.invalidFileList
      // }
      console.log(this.picList1)
      console.log(item)
      this.defaultInstanceIndex = this.picList1.findIndex(v => v.id == item.id)
      this.instanceTimer++
    },
    changeInstanceArrow(defaultAddImgIndex) {
      // this.selectImportantRow.showFileInstance = false
      // // console.log(this.$refs.instanceImgRef.defaultAddImgIndex)
      // this.selectImportantRow = this.importantFieldData[defaultAddImgIndex]
      // this.selectImportantRow.showFileInstance = true
    },
    handleClose() {
      // this.$emit('closeLook',1)
      this.$emit('update:showLookPic', false)
    },
    // async handleMarkFocus(item) {
    //   let res = await markFocus({
    //     id: item.id,
    //     focus: true
    //   })
    //   if (res.code == 0) {
    //     this.$message.success('成功')
    //     // 刷新列表
    //     this.handleTabClick()
    //   }
    // },
    lookOtherPic(item) {
      this.selectOtherFile = item
      this.showLookPic = true
    },
    closeLook(flag) {
      this.showLookPic = false
      if (flag) {
        this.handleTabClick()
      }
    },
    async handleTabClick() {
      // this.picList1 = []
      this.defaultInstanceIndex = null

      // if (this.activeName == "first") {
      //   this.searchClick(4)
      // }
      if (this.activeName == "second") {
        this.medicalFolderList = {}
        this.newestList = []
        this.current = 1
        await this.getMedicalFoldList();
        // this.picList1 = [].concat.apply([],Object.values(this.medicalFolderList))
      }
      if (this.activeName == "first") {
        this.otherFolderList = {}
        this.otherNewestList = []
        this.current = 1
        await this.getMedicalFoldList();
        // this.picList1 = [].concat.apply([],Object.values(this.otherFolderList))
      }
      if (this.activeName == "third") {
        await this.getInvalidList();
        // this.picList1 = this.invalidFileList
      }
    },
    searchFolder() {
      // this.medicalFolderList = {}
      // this.newestList = []
      // this.current = 1
      // this.getMedicalFoldList();
      this.handleTabClick()
    },
    // 合并对象中的数组
    concatObjArray(obj1, obj2) {
      for (let key in obj2) {
        if (obj1.hasOwnProperty(key)) {
          if (Array.isArray(obj1[key])) {
            obj1[key] = obj1[key].concat(obj2[key])
          }
        } else {
          obj1[key] = obj2[key]
        }
      }
      console.log(obj1)
      return obj1
    },
    // async freshMedicalFoldList() {
    //   this.medicalFolderList = {}
    //   this.newestList = []
    //   this.current = 1
    //   await this.getMedicalFoldList();
    // },
    async getMedicalFoldList() {
      // this.medicalFolderList = {}
      let res = await queryMedicalFold({
        patientId: this.patientId,
        startTime: this.medicalQueryObj.medicalQueryTime
          ? this.medicalQueryObj.medicalQueryTime[0]
          : "",
        endTime: this.medicalQueryObj.medicalQueryTime
          ? this.medicalQueryObj.medicalQueryTime[1]
          : "",
        nameLike: this.medicalQueryObj.nameLike,
        current: this.current,
        size: 10000,
        focus: this.activeName == 'first' ? false : true
      });
      if (res.code === 0) {
        // if (this.activeName == 'first') {
        //   this.picList1 = [].concat.apply([],Object.values(this.otherFolderList))
        // }
        // if (this.activeName == 'second') {
        //   this.picList1 = [].concat.apply([],Object.values(this.medicalFolderList))
        //   // console.log(this.picList1,'病历夹图片')
        // }
        // if (this.activeName == 'third') {
        //   this.picList1 = this.invalidFileList
        // }

        if (this.activeName == "second") {
          // socket和接口请求冲突时，数据重复
          if (res.data && JSON.stringify(res.data) != '{}' && JSON.stringify(this.medicalFolderList) != '{}') {
            if (Object.values(res.data)[0][0].id == Object.values(this.medicalFolderList)[0][0].id) return
          }
          this.newestList = [].concat.apply([],Object.values(res.data)) // 转一维数组
          this.concatObjArray(this.medicalFolderList,res.data);
          this.picList1 = [].concat.apply([],Object.values(this.medicalFolderList))
        }
        if (this.activeName == "first") {
          this.otherNewestList = [].concat.apply([],Object.values(res.data)) // 转一维数组
          this.concatObjArray(this.otherFolderList,res.data);
          this.picList1 = [].concat.apply([],Object.values(this.otherFolderList))
        }
        
        // console.log(this.medicalFolderList)
        this.$forceUpdate()
      }
    },
    searchInvalid() {
      this.getInvalidList()
    },
    async getInvalidList() {
      this.invalidFileList = [];
      let res = await getPatientFilesItemList({
        disabled: true,
        name: this.patientFilesItemV2VO.keyWord,
        patientId: this.patientId,
        wholeCourseId: this.patientFilesItemV2VO.wholeCourseId
      });
      if (res.code === 0) {
        res.data.forEach(v => {
          v.url = v.filePath
        })
        this.invalidFileList = res.data
        this.picList1 = this.invalidFileList
      }
    },
    // closeMedicalFolder() {
    //   this.medicalFolderStatus = false;
    // },
    // addMedicalFolder() {
    //   this.medicalFolderStatus = true;
    // },

    // async searchClick(type) {
    //   // if (this.activeName == "first") {
    //   //   this.$emit("getPatientRightData", type);
    //   // }
    //   if (this.activeName == "second") {
    //     await this.getMedicalFoldList();
    //   }
    //   if (this.activeName == "third") {
    //     await this.getInvalidList();
    //   }
    //   // this.$forceUpdate()
    // },
    // loadPatientFilesItem() {
    //   this.current++
    //   this.getMedicalFoldList()
    // },
    // loadFinishPatientFilesItem(type) {
    //   this.$emit("getPatientRightData", type, [
    //     "patientFilesItemV2VO",
    //     "ispatientFilesItemLoad"
    //   ]);
    // },
    // //点击弹出对照录入窗口
    // async toRefeDialog(item,routeEntry) {
    //   this.routeEntry = routeEntry
    //   // item.isView = viewStatus
    //   if (item.status == 3) return
    //   // 查看有效图片,不加锁
    //   if (routeEntry == 1) {
    //     this.crossReferenItem = DEEP_CLONE(item)

    //     // // this.crossReferenItem.status = this.crossReferenItem.statusName == '未录入' ? 1 : this.crossReferenItem.statusName == '已录入' ? 2 : null
    //     if(this.crossReferenItem.statusName == '未录入'){
    //       this.crossReferenItem.status = 1;
    //     }else if(this.crossReferenItem.statusName == '已录入'){
    //       this.crossReferenItem.status = 2;
    //     }else if(this.crossReferenItem.statusName == '草稿'){
    //       this.crossReferenItem.status = 5;
    //     }



    //     this.showCrossReferen = true
    //   } else {
    //     let res = await lockInGroupFile(item.inputGroupId)
    //     if (res.code == 0) {
    //       // 无效只能查看,保留恢复按钮
    //       this.crossReferenItem = DEEP_CLONE(item)
    //       // // this.crossReferenItem.status = this.crossReferenItem.statusName == '未录入' ? 1 : this.crossReferenItem.statusName == '已录入' ? 2 : null
    //       if(this.crossReferenItem.statusName == '未录入'){
    //         this.crossReferenItem.status = 1;
    //       }else if(this.crossReferenItem.statusName == '已录入'){
    //         this.crossReferenItem.status = 2;
    //       }else if(this.crossReferenItem.statusName == '草稿'){
    //         this.crossReferenItem.status = 5;
    //       }
    //       this.showCrossReferen = true
    //     }
    //   }
    // }
  },
  // sockets: {
  //   // 右侧数据-获取单独的病历夹列表
  //   rightData(data) {
  //     // console.log('实时获取病历夹对照录入数据')
  //     if (typeof data === "string") {
  //       data = JSON.parse(data);
  //     }
  //     let {
  //       data: { patientFilesItemV2VO }
  //     } = data.result;
  //     console.log(patientFilesItemV2VO,'实时获取病历夹对照录入数据')
  //     // 将socket返回的病历夹列表赋值给medicalFolderList
  //     // 判断病历夹列表是否有数据，有数据时更新
  //     if (patientFilesItemV2VO && patientFilesItemV2VO.caseHistoryItemListMap) {
  //       this.current = 1
  //       this.medicalFolderList = patientFilesItemV2VO.caseHistoryItemListMap;
  //       this.newestList = [].concat.apply([],Object.values(this.medicalFolderList)) // 转一维数组
  //     }
  //   }
  // }
};
</script>

<style lang="less">
// @import "@/views/treatment/components/RightContent/taskReminder.less";
.crossreference-tabs {
  .el-tabs__header {
    margin-bottom: 0;
  }
  .el-tabs__item {
    font-size: 12px;
    // color: #333333;
  }
  .el-tabs__nav-wrap::after {
    height: 0px !important;
  }
}
</style>
<style lang="less" scoped>
.crossReference-reminder-search {
  display: flex;
  padding: 20px 24px;
  padding-bottom: 0;
  margin-bottom: 10px;

  div {
    margin-right: 10px;
    label {
      margin-right: 8px;
    }
  }
}
/deep/.el-checkbox {
  margin-right: 0 !important;
}
.quote-all-check {
  margin: 0 20px;
  margin-left: 16px;
  margin-bottom: 16px;
  padding: 0 12px;
  display: flex;
  justify-content: space-between;
  // width: 614px;
  height: 36px;
  background: #E8F1FE;
  border-radius: 4px;
  align-items: center;
  .el-button {
    padding: 0 8px !important;
    color: #1a7bfc;
    border-color: #bad7fe;
    background: rgba(255,255,255,0.6);
  }
  .el-button.is-disabled {
    color: #c0c4cc !important;
    background-image: none !important;
    background-color: #fff !important;
    border-color: #ebeef5 !important;
  }
}
/deep/.el-dialog {
  width: fit-content;
}
/deep/.el-dialog__header {
  padding-bottom: 0;
}
/deep/.el-dialog__body {
  padding-top: 10px;
}
//对照录入
.crossreference-box {
  height: 100%;
  .crossreference-tabs {
    padding: 10px 24px 0;
    display: flex;
    justify-content: space-between;
  }
  .crossReference {
    // height: 100%;
    height: calc(100% - 64px);
    // width: 100%;
    position: relative;

    ul {
      padding: 0 15px;

      li {
        cursor: pointer;
        padding: 5px;
        // padding-right: 20px;
        height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .refeImg {
          height: 47px;
          width: 45px;

          img {
            height: 100%;
            width: 100%;
            // margin-right: 8px;
          }
        }

        .refeFileName {
          width: 50%;
          font-size: 12px;
          font-weight: bold;
          color: #363f4d;
          word-wrap: break-word;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          margin-left: 6px;

          .refeFileName-top {
            font-weight: bold;
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2; /* 这里是超出几行省略 */
            overflow: hidden;
          }

          .refeFileName-bot {
            font-size: 12px;
            color: #999;
            margin-top: 8px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }

        .upFileName {
          width: 26%;
          margin-left: 10px;
        }

        .fileType {
          display: flex;
          align-items: center;
          font-size: 12px;

          span {
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            margin-right: 5px;
          }
        }
      }

      li:hover {
        background-color: #edf4fe;
      }
    }
  }
  .medicalRecordFolder {
    .record-folder-content:last-child {
      ul:last-child {
        border-left: none;
      }
    }
    .record-folder-time {
      padding-left: 16px;
      // margin-bottom: 12px;
      // margin-top: 14px;
      .circle-dot {
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #1a7bfc;
        margin-right: 8px;
      }
      .time {
        font-size: 12px;
        color: #333333;
        &.update {
          color: #1a7bfc;
        }
        &.delete {
          color: #FB5555;
        }
      }
    }
    ul {
      padding-left: 0;
      margin-left: 20px;
      padding-top: 14px;
      padding-bottom: 12px;
      border-left: 1px solid #f0f0f0;
    }
  }
}

.look-Entry-pic {
  display: flex;
  height: 660px;
  .left-table {
    // flex: 1;
    // width: 50%;
    width: 660px;
    margin-right: 20px;
    /deep/.el-pagination {
      text-align: right;
      padding-top: 20px;
    }
  }
  .right-pic {
    // flex: 1;
    width: 560px;
    // background: rgba(51,51,51,0.85);
    // padding: 36px 20px;
    padding-top: 20px;
    .right-title {
      font-size: 16px;
      font-weight: 600;
      color: #FFFFFF;
      text-align: center;
      margin-bottom: 20px;
    }
    .right-btns {
      text-align: center;
      margin-bottom: 20px;
      .el-button {
        font-size: 12px;
        font-weight: 600;
        color: #000000;
      }
    }
    /deep/.el-carousel__container {
      height: 580px;
    }
    .quote-top-btn {
      text-align: right;
      margin-bottom: 30px;
      padding-right: 10px;
    }
  }
}


.refeImg {
  position: relative;
  .no-read {
    display: inline-block;
    width: 32px;
    height: 21px;
    border-radius: 2px;
    border: 1px solid #979797;
    text-align: center;
    line-height: 20px;
    position: absolute;
    top: 12px;
    left: -42px;
    color: #333333;
  }
  .yet-read {
    display: inline-block;
    width: 32px;
    height: 21px;
    border-radius: 2px;
    border: 1px solid #0CB79F;
    text-align: center;
    line-height: 20px;
    position: absolute;
    top: 12px;
    left: -42px;
    color: #0CB79F;
  }
}
/deep/.el-date-editor .el-range-separator {
  width: 30px;
}
.through-del {
  text-decoration: line-through;
}
.search-line {
  margin-bottom: 20px;
}
.refeFileName-top {
  img {
    width: 20px;
    height: 20px;
    vertical-align: middle;
  }
}
.option-entry-status {
  margin-left: 10px;
  cursor: pointer;
  .can-entry {
    display: block;
    width: 64px;
    height: 24px;
    background: #CFE4FF;
    border-radius: 2px;
    font-size: 12px;
    font-weight: 500;
    color: #1A7BFC;
    line-height: 24px;
    text-align: center;
  }
  .no-can-entry {
    display: block;
    width: 64px;
    height: 24px; 
    background: #E7E7E7;
    border-radius: 2px;
    font-size: 12px;
    font-weight: 500;
    color: #999999;
    line-height: 24px;
    text-align: center;
    cursor: not-allowed;
  }
}
</style>